import { render } from "./GfbRadioGroup.vue?vue&type=template&id=16bb6873"
import script from "./GfbRadioGroup.vue?vue&type=script&lang=js"
export * from "./GfbRadioGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__